export default [
  {
    path: '/appRegulated/appRegulated',
    name: 'appRegulated',
    meta: {
      title: '估价管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "merchantIntention" */ '@/views/appRegulated/appRegulated.vue'
      )
  },
  {
    path: '/appRegulated/appRegulateDelt',
    name: 'appRegulateDelt',
    meta: {
      title: '估价管理编辑'
    },
    component: () =>
      import(
        /* webpackChunkName: "merchantIntention" */ '@/views/appRegulated/appRegulateDelt.vue'
      )
  },
  {
    path: '/appRegulated/systematic',
    name: 'systematic',
    meta: {
      title: '分类管理'
    },
    component: () =>
      import(
        /* webpackChunkName: "merchantIntention" */ '@/views/appRegulated/systematic.vue'
      )
  },

]
